import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import NoMatch from './NoMatch';
import LandingPage from '@ids/pages/landing';
import Questionnaire from '@ids/pages/questionnaire';
import OverstepPage from '@ids/pages/overstep';

export const PATHS = {
    APP_ROOT: '/app/m/westwingstudio',
    ROOT: '/m/westwingstudio',
    LANDING_PAGE: '/',
    QUESTIONNAIRE: '/wizard/project',
    OVERSTEP: '/wizard/overstep',
    NOT_IDS: '*',
};

export interface RouteInterface {
    path: string;
    code: number;
    exact: boolean;
    component: React.FC<RouteComponentProps>;
}

const routes: Array<RouteInterface> = [
    {
        path: PATHS.LANDING_PAGE,
        code: 200,
        exact: true,
        component: LandingPage,
    },
    {
        path: PATHS.QUESTIONNAIRE,
        code: 200,
        exact: true,
        component: Questionnaire,
    },
    {
        path: PATHS.OVERSTEP,
        code: 200,
        exact: true,
        component: OverstepPage,
    },
    {
        path: PATHS.NOT_IDS,
        code: 301,
        exact: true,
        component: NoMatch,
    },
];

export default routes;
